import {
  Page,
  Text,
  View,
  Document,
  Image,
  Svg,
  Path,
  Rect,
  StyleSheet,
} from '@react-pdf/renderer';
import { dateFormat } from '../../../../../lib/format/format';
import color from '../../../../../assets/css/colors';
import { PdfCoApplicantInformation } from './PdfCoApplicantInformation';
import { PdfAccountInformation } from './PdfAccountInformation';
import { PdfIdentityInformation } from './PdfIdentityInformation';
import { PdfPrimaryOfficerInformation } from './PdfPrimaryOfficerInformation';
import { PdfCoOfficerInformation } from './PdfCoOfficerInformation';

const styles = StyleSheet.create({
  wrapper: {
    fontSize: 10,
    color: '#1c1c1c',
    backgroundColor: color.light.main,
    padding: 30,
  },
  grdRow: {
    flexDirection: 'row',
    marginBottom: 10,
  },
  grdCell: {
    flexGrow: 1,
    display: 'block',
    wordBreak: 'break-word',
    padding: 5,
  },
  grdHeader: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 10,
    color: color.light.main,
    textTransform: 'uppercase',
    backgroundColor: '#1c1c1c',
    padding: 7,
  },
  grdSubHeader: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 10,
    color: color.light.main,
    textTransform: 'uppercase',
    backgroundColor: '#1c1c1c',
    padding: 4,
  },
  BT: {
    borderTop: '1px solid #1c1c1c',
    borderCollapse: 'collapse',
  },
  BB: {
    borderBottom: '1px solid #1c1c1c',
    borderCollapse: 'collapse',
  },
  BL: {
    borderLeft: '1px solid #1c1c1c',
    borderCollapse: 'collapse',
  },
  BR: {
    borderRight: '1px solid #1c1c1c',
    borderCollapse: 'collapse',
  },
  imageSignature: {
    width: 100,
    height: 'auto',
  },
  imageLogo: {
    width: 90,
    height: 'auto',
    marginBottom: 30,
  },
  imageThumbnail: {
    width: '100%',
    height: 250,
    objectFit: 'contain',
    padding: 20,
    border: '1px solid #ececec',
    backgroundColor: '#ececec',
    display: 'inline',
  },
  h1: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 12,
    textTransform: 'capitalize',
    textAlign: 'left',
    margin: '40px 5px 20px 5px',
    padding: 4,
    borderTop: '1px solid #1c1c1c',
    borderBottom: '1px solid #1c1c1c',
  },
  label: {
    fontSize: 10,
    color: '#424242',
    marginBottom: 4,
  },
  text: {
    color: '#202020',
    textTransform: 'uppercase',
    fontFamily: 'Helvetica-Bold',
  },
  text2: {
    color: '#202020',
    fontFamily: 'Helvetica-Bold',
  },
  textSmall: {
    fontSize: 15,
    color: '#424242',
    marginBottom: 4,
  },
  centerVH: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mR8: { marginRight: 8 },
  mR20: { marginRight: 20 },
  mT5: { marginTop: 5 },
  mT10: { marginTop: 10 },
  mT20: { marginTop: 20 },
  mB5: { marginBottom: 5 },
  mB10: { marginBottom: 10 },
  mB20: { marginBottom: 20 },
  mB30: { marginBottom: 30 },
  mB80: { marginBottom: 40 },
  nM: { margin: '0 !important' },
  nP: { padding: '0 !important' },
});

const CheckBox = () => (
  <Svg style={{ width: 15, height: 15 }} viewBox="0 0 130 130" fill="none">
    <Rect style={{ width: 15, height: 15 }} rx="10" />
    <Rect
      width="130"
      height="130"
      fill="white"
      stroke="#373737"
      stroke-width="24"
      mask="url(#path-1-inside-1)"
    />
    <Rect transform="translate(29 29)" fill="white" />
    <Path
      d="M82.6435 48.6296L58.2104 73.0954L48.3543 63.2078L48.3476 63.2011L48.3408 63.1945C47.9206 62.7886 47.4245 62.4694 46.881 62.2552C46.3374 62.041 45.757 61.936 45.1728 61.9461C44.5886 61.9562 44.0122 62.0812 43.4764 62.3141C42.9405 62.547 42.4558 62.8832 42.0499 63.3034C41.644 63.7236 41.3248 64.2196 41.1106 64.7632C40.8964 65.3068 40.7913 65.8872 40.8014 66.4714C40.8116 67.0555 40.9366 67.632 41.1695 68.1678C41.4012 68.7008 41.735 69.1833 42.1522 69.5879L55.1035 82.5392C55.1041 82.5398 55.1047 82.5404 55.1053 82.541C55.5116 82.9502 55.9949 83.2751 56.5272 83.4969C57.0604 83.719 57.6322 83.8333 58.2098 83.8333C58.7873 83.8333 59.3592 83.719 59.8923 83.4969C60.4247 83.2751 60.9079 82.9502 61.3143 82.541C61.3149 82.5404 61.3154 82.5398 61.316 82.5392L88.8398 55.0154C89.2765 54.6085 89.6255 54.1166 89.865 53.5697C90.1074 53.0162 90.2325 52.4186 90.2325 51.8144C90.2325 51.2102 90.1074 50.6125 89.865 50.0591C89.6255 49.5125 89.2768 49.0206 88.8404 48.6139C88.4369 48.2112 87.9586 47.8912 87.4323 47.6719C86.8992 47.4498 86.3273 47.3354 85.7498 47.3354C85.1722 47.3354 84.6004 47.4498 84.0672 47.6719C83.5347 47.8938 83.0513 48.2188 82.6449 48.6282C82.6444 48.6286 82.644 48.6291 82.6435 48.6296Z"
      fill="#292929"
      stroke="black"
      stroke-width="6"
    />
  </Svg>
);

export const GeneratePDF = (account, dynamicDisclosures, correspondentData) => {
  const { logo, brokerName, brokerAddress, brokerCity, brokerState, brokerZip } =
    correspondentData;

  const {
    wrapper,
    grdRow,
    grdCell,
    grdHeader,
    grdSubHeader,
    BT,
    BB,
    BL,
    BR,
    label,
    text,
    text2,
    mT10,
    mT20,
    nM,
    nP,
    centerVH,
  } = styles;

  const CorporationInformation = () => (
    <View style={[grdRow]}>
      <View style={[grdCell]}>
        <View style={[grdHeader]}>
          <Text>Account Information</Text>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL, { width: 33.33 }]}>
            <Text style={label}>First Name:</Text>
            <Text style={[text]}>{account.primaryOwner.firstName}</Text>
          </View>
          <View style={[grdCell, BB, BL, { width: 33.33 }]}>
            <Text style={label}>Middle Name:</Text>
            <Text style={[text]}>{account.primaryOwner.middleName}</Text>
          </View>
          <View style={[grdCell, BB, BR, BL, { width: 33.33 }]}>
            <Text style={label}>Last Name:</Text>
            <Text style={[text]}>{account.primaryOwner.lastName}</Text>
          </View>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL, { width: 33.33 }]}>
            <Text style={label}>Email Address:</Text>
            <Text style={[text]}>{account.primaryOwner.email}</Text>
          </View>
          <View style={[grdCell, BB, BL, { width: 33.33 }]}>
            <Text style={label}>Phone Number:</Text>
            <Text style={[text]}>{account.primaryOwner.phone}</Text>
          </View>
          <View style={[grdCell, BB, BR, BL, { width: 33.33 }]}>
            <Text style={label}>Birth Date:</Text>
            <Text style={[text]}>
              {dateFormat(account.primaryOwner.identification.dateOfBirth)}
            </Text>
          </View>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL, { width: 10 }]}>
            <Text style={label}>Account Type:</Text>
            <Text style={[text]}>{account.accountType}</Text>
          </View>
          <View style={[grdCell, BB, BL, { width: 200 }]}>
            <Text style={label}>Company Name:</Text>
            <Text style={[text]}>{account.accountName}</Text>
          </View>
          <View style={[grdCell, BB, BL, BR, { width: 106 }]}>
            <Text style={label}>EIN or Tax ID:</Text>
            <Text style={[text]}>{account.tin}</Text>
          </View>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BL, BB, { width: 50 }]}>
            <Text style={label}>Address:</Text>
            <Text style={[text]}>
              {account.primaryOwner.address1} {account.primaryOwner.address2}
            </Text>
          </View>
          <View style={[grdCell, BB, BL, BR, { width: 50 }]}>
            <Text style={label}>City:</Text>
            <Text style={[text]}>{account.primaryOwner.city}</Text>
          </View>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BL, { width: 33.33 }]}>
            <Text style={label}>State:</Text>
            <Text style={[text]}>{account.primaryOwner.state}</Text>
          </View>
          <View style={[grdCell, BL, { width: 33.33 }]}>
            <Text style={label}>Zip Code:</Text>
            <Text style={[text]}>{account.primaryOwner.zip}</Text>
          </View>
          <View style={[grdCell, BL, BR, { width: 33.33 }]}>
            <Text style={label}>Country:</Text>
            <Text style={[text]}>{account.primaryOwner.country}</Text>
          </View>
        </View>
        <View style={[grdSubHeader, { textAlign: 'center' }]}>
          <Text>Proof of Address:</Text>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL, BR]}>
            {account.primaryOwner.imgProofOfAddress ? (
              <Image
                style={styles.imageThumbnail}
                src={{ uri: account.primaryOwner.imgProofOfAddress, method: 'GET' }}
              />
            ) : (
              <Text style={[{ textAlign: 'center' }]}>No proof of address provided.</Text>
            )}
          </View>
        </View>
      </View>
    </View>
  );

  const TrustedContact = () => (
    <View style={[grdCell]}>
      <View style={[grdHeader]}>
        <Text>Trusted Contact</Text>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>Complete Name</Text>
          <Text
            style={[text]}
          >{`${account.trustedContact.firstName} ${account.trustedContact.middleName} ${account.trustedContact.lastName}`}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>Complete Address</Text>
          <Text
            style={[text]}
          >{`${account.trustedContact.address1}, ${account.trustedContact.city}, ${account.trustedContact.addressState}, ${account.trustedContact.country}`}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>Relationship</Text>
          <Text style={[text]}>{account.trustedContact.relationship}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>Birth Date</Text>
          <Text style={[text]}>{dateFormat(account.trustedContact.dateOfBirth)}</Text>
        </View>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>Identification Type</Text>
          <Text style={[text]}>{account.trustedContact.identificationType}</Text>
        </View>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>ID</Text>
          <Text style={[text]}>{account.trustedContact.identificationValue}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>Email</Text>
          <Text style={[text]}>{account.trustedContact.email}</Text>
        </View>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>Contact Number</Text>
          <Text style={[text]}>{account.trustedContact.phone}</Text>
        </View>
      </View>
    </View>
  );

  const EmploymentInfo = () => (
    <View style={[grdCell]}>
      <View style={[grdHeader]}>
        <Text>Employment</Text>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BT, BB, BL, BR]}>
          <Text style={label}>Employment Status:</Text>
          <Text style={[text]}>{account.primaryOwner.employment.employmentStatus}</Text>
        </View>
      </View>
      {['Employed', 'Self-Employed'].includes(
        account.primaryOwner.employment.employmentStatus
      ) && (
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL]}>
            <Text style={label}>
              {account.primaryOwner.employment.employmentStatus === 'Employed'
                ? 'Employer Name:'
                : 'Doing Bussiness As:'}
            </Text>
            <Text style={[text]}>
              {account.primaryOwner.employment.employmentStatus === 'Employed'
                ? account.primaryOwner.employment.employmentName
                : account.primaryOwner.employment.natureOfBusiness}
            </Text>
          </View>
          <View style={[grdCell, BB, BL, BR]}>
            <Text style={label}>Occupation:</Text>
            <Text style={[text]}>
              {account.primaryOwner.employment.employmentOccupation}
            </Text>
          </View>
        </View>
      )}
    </View>
  );

  const AssociationInfo = () => (
    <View style={[grdCell]}>
      <View style={[grdHeader]}>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, nP, { width: 250 }]}>
            <Text>Association</Text>
          </View>
          <View style={[grdCell, nP, { width: 50, textAlign: 'center' }]}>
            <Text>Yes</Text>
          </View>
          <View style={[grdCell, nP, { width: 50, textAlign: 'center' }]}>
            <Text>No</Text>
          </View>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR, { width: 250 }]}>
          <Text>
            Are you or a family member a senior executive or 10% or greater shareholder of
            a publicly traded company?
          </Text>
          {account.primaryOwner.association.ownership === 'Yes' && (
            <View>
              <Text style={[label, mT20]}>Stock Symbol:</Text>
              <Text style={[text]}>
                {account.primaryOwner.association.stockOwnership}
              </Text>
            </View>
          )}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {account.primaryOwner.association.ownership === 'Yes' && <CheckBox />}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {account.primaryOwner.association.ownership === 'No' && <CheckBox />}
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR, { width: 250 }]}>
          <Text>
            Are you or a family member employed with a member firm of a stock exchange or
            Finra registered broker?
          </Text>
          {account.primaryOwner.association.brokerMember === 'Yes' && (
            <View>
              <Text style={[label, mT20]}>Name of the Company:</Text>
              <Text style={[text]}>{account.primaryOwner.association.brokerName}</Text>
              <Text style={[label, mT10]}>Name of the Affiliated Person:</Text>
              <Text style={[text]}>
                {account.primaryOwner.association.affiliatePerson}
              </Text>
              <Text style={[label, mT10]}>Postion of the Affiliated Person:</Text>
              <Text style={[text]}>
                {account.primaryOwner.association.affiliatePersonPosition}
              </Text>
            </View>
          )}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {account.primaryOwner.association.brokerMember === 'Yes' && <CheckBox />}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {account.primaryOwner.association.brokerMember === 'No' && <CheckBox />}
        </View>
      </View>
    </View>
  );

  const TradingInfo = () => (
    <View style={[grdCell]}>
      <View style={[grdHeader]}>
        <Text>Trading</Text>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>Margin Type:</Text>
          <Text style={[text]}>{account.marginType}</Text>
        </View>
        <View style={[grdCell, BB, BR]}>
          <Text style={label}>Trading Privileges:</Text>
          <Text style={[text]}>
            {account.stocks ? 'Stocks' : ''}
            {account.option ? ', Options' : ''}
          </Text>
        </View>
      </View>
    </View>
  );

  const ObjectiveInfo = () => (
    <View style={[grdCell]}>
      <View style={[grdHeader]}>
        <Text>Objective</Text>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR]}>
          <Text style={label}>Investment Objective:</Text>
          <Text style={[text]}>{account.objective.investmentObjectiveCode}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, { width: 50 }]}>
          <Text style={label}>Annual Income:</Text>
          <Text style={[text]}>{account.objective.annualIncome}</Text>
        </View>
        <View style={[grdCell, BB, BL, BR, { width: 50 }]}>
          <Text style={label}>Liquid Net Worth:</Text>
          <Text style={[text]}>{account.objective.liquidNetWorth}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, { width: 50 }]}>
          <Text style={label}>What are you using to fund this account?</Text>
          <Text style={[text]}>{account.objective.sourceOfFunds}</Text>
        </View>
        <View style={[grdCell, BB, BL, BR, { width: 50 }]}>
          <Text style={label}>Risk Tolerance:</Text>
          <Text style={[text]}>{account.objective.riskTolerance}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        {!!account.objective.sourceOfFundsDescription && (
          <View style={[grdCell, BB, BL, BR]}>
            <Text style={label}>Other</Text>
            <Text style={[text]}>{account.objective.sourceOfFundsDescription}</Text>
          </View>
        )}
      </View>
    </View>
  );

  const AgreementInfo = () => (
    <View style={[grdCell]}>
      <View style={[grdHeader]}>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, nP, { width: 250 }]}>
            <Text>Signed Disclosures</Text>
          </View>
          <View style={[grdCell, nP, { width: 50, textAlign: 'center' }]}>
            <Text>Yes</Text>
          </View>
          <View style={[grdCell, nP, { width: 50, textAlign: 'center' }]}>
            <Text>No</Text>
          </View>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR, { width: 250 }]}>
          <Text>Margin Agreement</Text>
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {account.marginAgreement && <CheckBox />}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {!account.marginAgreement && <CheckBox />}
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR, { width: 250 }]}>
          <Text>Margin Disclosure Statement</Text>
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {account.marginDisclosure && <CheckBox />}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {!account.marginDisclosure && <CheckBox />}
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, BR, { width: 250 }]}>
          <Text>Customer Account Agreement</Text>
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {account.customerAccountAgreement && <CheckBox />}
        </View>
        <View
          style={[
            grdCell,
            BB,
            BR,
            {
              width: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          ]}
        >
          {!account.customerAccountAgreement && <CheckBox />}
        </View>
      </View>
      {dynamicDisclosures?.map((disclosure, index) => (
        <View key={index} break={index === 7} style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL, BR, { width: 250 }, index === 7 && BT]}>
            <Text>{disclosure.title}</Text>
          </View>
          <View
            style={[
              grdCell,
              BB,
              BR,
              {
                width: 50,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              },
              index === 7 ? BT : null,
            ]}
          >
            {disclosure.checked === true && <CheckBox />}
          </View>
          <View
            style={[
              grdCell,
              BB,
              BR,
              {
                width: 50,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              },
              index === 7 ? BT : null,
            ]}
          >
            {disclosure.checked === false && <CheckBox />}
          </View>
        </View>
      ))}
    </View>
  );

  const ESignature = () => (
    <View
      style={[
        grdRow,
        nM,
        {
          marginTop: 50,
          justifyContent: 'center',
          alignItems: 'flex-end',
        },
      ]}
    >
      <View style={[centerVH, { margin: '0px 25px' }]}>
        <Text
          style={{
            padding: '5px 5px',
          }}
        >
          {account.imgSignature}
        </Text>
        <Text
          style={{
            padding: '5px 30px',
            borderBottom: '1px solid black',
          }}
        >
          {account.primaryOwner.firstName} {account.primaryOwner.middleName}{' '}
          {account.primaryOwner.lastName}
        </Text>
        <Text style={{ marginTop: 5 }}>Primary Applicant Signature</Text>
      </View>
      {account.accountType === 'J' && (
        <View style={[centerVH, { margin: '0px 25px' }]}>
          <Text
            style={{
              padding: '5px 5px',
            }}
          >
            {account.coApplicantSignature}
          </Text>
          <Text
            style={{
              padding: '5px 30px',
              borderBottom: '1px solid black',
            }}
          >
            {account.jointOwner.firstName} {account.jointOwner.middleName}{' '}
            {account.jointOwner.lastName}
          </Text>
          <Text style={{ marginTop: 5 }}>Co-Applicant Signature</Text>
        </View>
      )}
    </View>
  );

  const document = (
    <Document
      title={`${brokerName} Trading Application Form`}
      author="Software Algo Solutions"
      subject="Trading Form"
      keywords="Trading"
      producer="Software Algo Solutions"
      pdfVersion="1"
      creator="Software Algo Solutions"
      name="Software Algo Solutions"
      fileName="Software Algo Solution"
    >
      <Page size="A4" style={wrapper}>
        <View style={grdCell}>
          <View>
            <Image style={styles.imageLogo} src={{ uri: logo, method: 'GET' }} />

            <Text style={[text2, { marginBottom: 3, fontSize: 9, textAlign: 'right' }]}>
              {brokerName}
            </Text>
            <Text style={[text2, { marginBottom: 3, fontSize: 9, textAlign: 'right' }]}>
              {brokerAddress}, {brokerCity}
            </Text>
            <Text style={[text2, { marginBottom: 5, fontSize: 9, textAlign: 'right' }]}>
              {brokerState}, {brokerZip}
            </Text>
            <Text style={[text2, { marginBottom: 10, fontSize: 10, textAlign: 'right' }]}>
              Member SIPC & FINRA
            </Text>
          </View>
          <View>
            <Text style={[text2, { marginBottom: 10, fontSize: 12 }]}>
              New Account Application
            </Text>
            <Text style={[text, { marginBottom: 5, fontSize: 12 }]}>
              Account: {account.correspondent}-{account.accountNo} Account Title:{' '}
              {account.primaryOwner.firstName} {account.primaryOwner.lastName}
            </Text>
          </View>
          {account.accountType !== 'C' ? (
            <View>
              {PdfAccountInformation(account, styles)}
              {account.accountType === 'J' && PdfCoApplicantInformation(account, styles)}
            </View>
          ) : (
            <View>
              <CorporationInformation />
            </View>
          )}
        </View>
      </Page>
      {account.accountType === 'C' && (
        <Page size="A4" style={wrapper}>
          {PdfPrimaryOfficerInformation(account, styles)}
        </Page>
      )}
      {account.accountType === 'C' && PdfCoOfficerInformation(account, styles)}
      {['I', 'J'].includes(account.accountType) && (
        <Page size="A4" style={wrapper}>
          {PdfIdentityInformation(account, styles)}
        </Page>
      )}
      <Page size="A4" style={wrapper}>
        {!!account.trustedContact?.ownerId && (
          <View>
            <TrustedContact />
          </View>
        )}
        {account.accountType !== 'C' && (
          <View>
            <EmploymentInfo />
          </View>
        )}
        <View>
          <AssociationInfo />
        </View>
        <View>
          <TradingInfo />
        </View>
        <View>
          <ObjectiveInfo />
        </View>
        <View>
          <AgreementInfo />
        </View>
        <ESignature />
      </Page>
    </Document>
  );

  return document;
};
